import React from "react";
import SelectableCardList from "./SelectableCardList";
export default class CardItem extends React.Component {
  onListChanged(selected) {
    this.setState({
      selected: selected,
    });
    this.props.onGetCard(selected);
  }
  submit() {
    window.alert("Selected: " + this.state.selected);
  }
  render() {
    return (      
        <SelectableCardList
          multiple={this.props.multiple}
          maxSelectable={this.props.maxSelectable}
          contents={this.props.cardContents}
          onChange={this.onListChanged.bind(this)}
        />
    );
  }
}
